import React from "react";
import {
  GenericTextField,
  GenericNumberField,
  GenericDateField,
  GenericCheckboxField,
  GenericLookupField,
  GenericTextFieldProps,
  GenericNumberFieldProps,
  GenericDateFieldProps,
  GenericCheckboxFieldProps,
  GenericLookupFieldProps,
} from "../../../../components/common/FormFields";

// Vehicle-specific typed versions of generic components
export const VehicleTextField: React.FC<GenericTextFieldProps> = (props) => (
  <GenericTextField {...props} />
);

export const VehicleNumberField: React.FC<GenericNumberFieldProps> = (props) => (
  <GenericNumberField {...props} />
);

export const VehicleDateField: React.FC<GenericDateFieldProps> = (props) => (
  <GenericDateField {...props} />
);

export const VehicleCheckboxField: React.FC<GenericCheckboxFieldProps> = (props) => (
  <GenericCheckboxField {...props} />
);

export const VehicleLookupField: React.FC<GenericLookupFieldProps> = (props) => (
  <GenericLookupField {...props} />
);
